import { fbt } from 'fbtee'
import { ChevronRight, Info } from 'lucide-react'
import { SettingsRow } from '../../components/SettingsCard'
import { useTransitionNavigate } from '../../lib/viewTransition'
import { SettingsSection } from './SettingsSection'

export function AboutSection() {
  const navigate = useTransitionNavigate()
  return (
    <SettingsSection title={<fbt desc="About section label in Settings">About</fbt>}>
      <SettingsRow
        icon={<Info className="size-4" />}
        label={fbt('Version', 'App version label in Settings')}
        trailing={
          <span className="flex items-center gap-1.5 text-sm text-muted-foreground">
            <span className="font-mono">{import.meta.env.VITE_OTA_VERSION ?? '—'}</span>
            <ChevronRight className="size-4" />
          </span>
        }
        onClick={() => navigate('/settings/debug')}
        buttonProps={{ 'data-testid': 'settings-version-row' }}
      />
    </SettingsSection>
  )
}
